import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_CAREVILLE_API_BASE_URL;
// const API_BASE_URL = "https://pms0jpsd-5061.inc1.devtunnels.ms";

const token = localStorage.getItem("careToken");

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export default client;
